// routerServiceV7.ts
// Service khusus untuk RouterOS v7
import api from './api';

const routerServiceV7 = {
  getRouterDetails: (id: string) => api.get(`/routers/${id}/details`),
  getRouterResources: (id: string) => api.get(`/routers/${id}/resources`),
  getPPPActiveConnections: (id: string) => api.get(`/routers/${id}/ppp-connections`),
  // Tambahkan endpoint lain khusus v7 jika perlu
};

export default routerServiceV7;
